import { Tune } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

// Decoupled Filters trigger for RubiALERT. Only opens the filter panel; the
// panel itself (<AlertFilters>) and the active-filter chips are rendered by the
// parent. Maps to the future @rubi/ui FiltersButton (which will bundle trigger
// + popover) once that component supports controlled open state.
interface AlertFilterButtonProps {
  onClick: () => void;
}

const AlertFilterButton = ({ onClick }: AlertFilterButtonProps) => {
  const { t } = useTranslation("bulletin/searchbar");

  return (
    <Button
      className="ml-3"
      sx={{ width: "200px", padding: "0" }}
      variant="outlined"
      onClick={onClick}
    >
      <Tune />
      <span className="ml-2 d-none d-md-block">{t("filters")}</span>
    </Button>
  );
};

export default AlertFilterButton;
